import { Injectable } from '@angular/core'
import { TmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimLineRemittanceAdvice extends IModelBase {
  ClaimId: number
  ServiceId: number
  Code: string
}

@Injectable()
export class ClaimLineRemittanceAdviceODataService extends ODataService<IClaimLineRemittanceAdvice> {
  constructor(
    protected http: HttpClient,
    protected config: TmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ServiceRemittanceAdvices'
  }
}
